import { useEffect } from 'react';

import { PlotGroupFiltersEnum, PlotGroupGroupByEnum, PlotLabelValue } from '@/api/rest/resources/types/plotGroup';
import { WidgetType } from '@/api/rest/resources/types/widget';
import { usePlotLabelNameValues } from '@/pages/shared/hooks/usePlotLabels';

import { useControlsContext } from '../o/Form/Form';

export const useFormSectionPlotLabelValues = () => {
  const { watch, setValue } = useControlsContext();

  const [formLabel, formPlotLabelValues] = watch([PlotGroupGroupByEnum.labels, PlotGroupFiltersEnum.plot__labels__id]);

  const availablePlotLabelValues: PlotLabelValue[] = usePlotLabelNameValues(formLabel?.id).data?.results ?? [];

  useEffect(() => {
    if (formPlotLabelValues?.length && formLabel?.id) {
      const onlyLinkedPlotLabelValues = formPlotLabelValues.filter(
        (value: PlotLabelValue) => value.label_name_id === formLabel.id,
      );
      setValue(PlotGroupFiltersEnum.plot__labels__id, onlyLinkedPlotLabelValues);
    }
  }, [formLabel?.id, formPlotLabelValues, setValue]);

  return {
    name: 'plot_group_filters_dialog_body_section_plot_labels_values',
    type: WidgetType.o_form_section,
    visible: true,
    relatedData: {
      previewChildrenLimit: 6,
      spacing: 2,
      className: 'py-4 border-b border-divider',
      label: {
        i18nPath: 'global.widget.filters.sections.plot__labels__id.title',
        className: 'uppercase typography-overline py-2 font-semibold',
      },
      section: {
        className: 'w-fit flex-wrap',
        centerMain: true,
        direction: 'row',
        spacing: 2,
      },
      formName: PlotGroupFiltersEnum.plot__labels__id,
    },
    widgets: [
      {
        name: 'plot_group_filters_dialog_body_section_plot_labels_value_no_data',
        visible: availablePlotLabelValues.length === 0,
        type: WidgetType.a_text,
        relatedData: {
          i18nPath: 'global.widget.filters.sections.plot__labels__id.noData',
          className: 'typography-body2 text-text-secondary',
        },
      },
      {
        name: 'plot_group_filters_dialog_body_section_plot_labels_value_form',
        visible: availablePlotLabelValues.length > 0,
        type: WidgetType.o_form_button,
        relatedData: {
          data: availablePlotLabelValues.map((label) => ({
            text: label.value,
            formName: PlotGroupFiltersEnum.plot__labels__id,
            value: label,
          })),
        },
        repeat: {
          data: 'relatedData.data',
          key: 'value',
          template: {
            name: 'plot_group_filters_dialog_body_section_plot_labels_value_button',
            type: WidgetType.o_form_button,
            visible: true,
            relatedData: {
              variant: 'outline',
              className: 'w-fit whitespace-nowrap',
            },
          },
        },
      },
    ],
  };
};
